import { Desktop } from "./Desktop";

export const AccountCreated = () => (
	<>
		<main className="main">
			<section className="js-section section check-mail">
				<div className="wrapper">
					<div className="completed-inner">
						<div className="completed-img">
							<img src="/images/email.svg" alt="" />
						</div>
						<h2 className="completed-subtitle">Check your mail</h2>
						<div className="form-sub-title">
							We have sent an email verification instructions to your email
						</div>
					</div>
				</div>
			</section>
			<Desktop />
		</main>
	</>
)
